import React, { memo, useMemo } from 'react'
import tw from 'twin.macro'
import { RowActionsMenu } from 'src/components/shared/grid/RowActionsMenu'
import type { CustomerProduct } from 'src/interfaces/customerProduct'
import type { MenuActionItem } from 'src/interfaces/ui'
import { GSIcon } from 'src/components/shared/GSIcon'

interface Props {
  product: CustomerProduct
  onEdit(product: CustomerProduct): void
  onDeactivate(product: CustomerProduct): void
}

const CustomerProductActionsCellComponent = ({ product, onEdit, onDeactivate }: Props) => {
  const items = useMemo<MenuActionItem[]>(() => {
    return [
      {
        label: 'Edit end time',
        icon: <GSIcon iconName="gs_pencil" size={20} css={tw`text-shades-1000`} />,
        dataTestId: `customer-products-edit-${product.id}`,
        onClick: () => {
          onEdit(product)
        },
      },
      {
        label: 'Deactivate',
        icon: <GSIcon iconName="gs_pause" size={20} css={tw`text-critical-500`} />,
        color: 'var(--mui-critical-500)',
        dataTestId: `customer-products-deactivate-${product.id}`,
        onClick: () => {
          onDeactivate(product)
        },
      },
    ]
  }, [product, onEdit, onDeactivate])

  return (
    <RowActionsMenu
      items={items}
      ariaLabel="Product actions"
      dataTestId={`customer-products-actions-${product.id}`}
    />
  )
}

export const CustomerProductActionsCell = memo(CustomerProductActionsCellComponent)
